var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { NavigationMenuItem } from './navigation-menu-item';
import { classNames } from '@shapeable/utils';
import AnimateHeight from 'react-animate-height';
import { SiteMenuTitle } from '../entities/site-menu-title';
import { useLang } from '../hooks/use-lang';
var cls = classNames('navigation-menu');
export var NavigationMenuDefaultProps = {
  itemIsAvailable: function () {
    return true;
  },
  items: [],
  showTitle: true
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    font-size: 1em;\n  "], ["\n    width: 100%;\n    font-size: 1em;\n  "]))),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ItemsStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 100%;\n    font-size: 1em;\n    margin: 0;\n    padding: 0;\n  "], ["\n    width: 100%;\n    font-size: 1em;\n    margin: 0;\n    padding: 0;\n  "]))),
  tablet: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ItemStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    cursor: pointer;\n    border-bottom: 1px dashed #333;\n\n    &:last-child {\n      border-bottom: none;\n    }\n  "], ["\n    cursor: pointer;\n    border-bottom: 1px dashed #333;\n\n    &:last-child {\n      border-bottom: none;\n    }\n  "])))
});
var ChildrenStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin: 0;\n    padding: 0;\n  "], ["\n    margin: 0;\n    padding: 0;\n  "])))
});
var ChildStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    cursor: pointer;\n    a {\n      padding-left: ", ";\n    }\n  "], ["\n    cursor: pointer;\n    a {\n      padding-left: ", ";\n    }\n  "])), theme.UNIT(7))
});
var MobileMenuStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "]))),
  desktop: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Items: styled.ul(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ItemsStyles),
  Item: styled(NavigationMenuItem)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles),
  MobileMenu: styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), MobileMenuStyles),
  Children: styled.ul.attrs(cls.attr('item-children'))(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ChildrenStyles),
  Child: styled(NavigationMenuItem)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ChildStyles)
};
export var NavigationMenu = React.forwardRef(function (props, ref) {
  var className = props.className,
    items = props.items,
    mobileChildren = props.mobileChildren,
    onItemClick = props.onItemClick,
    itemIsAvailable = props.itemIsAvailable,
    showTitle = props.showTitle;
  var t = useLang();
  return React.createElement(My.Container, {
    ref: ref,
    className: cls.name(className)
  }, showTitle && React.createElement(SiteMenuTitle, null, t('Site Navigation')), React.createElement(My.Items, null, items.map(function (item) {
    var _a;
    /* @ts-ignore */
    var isAvailable = itemIsAvailable(item);
    if (!isAvailable) {
      return null;
    }
    var href = item.url || item.path || ((_a = item.page) === null || _a === void 0 ? void 0 : _a.path);
    var hasChildren = item.children && item.children.length > 0;
    var childIsActive = hasChildren && item.children.find(function (child) {
      return child.isActive;
    });
    var isDisclosed = item.isDisclosed || childIsActive;
    return React.createElement(My.Item, {
      entity: item,
      onClick: item.onClick || function () {
        onItemClick(item);
      },
      key: item.id,
      icon: item.__icon,
      href: item.hasChildren ? undefined : href,
      isActive: item.isActive && !item.hasChildren,
      label: item.name
    }, React.createElement(AnimateHeight, {
      duration: 200,
      height: isDisclosed ? 'auto' : 0
    }, React.createElement(My.Children, null, item.children.map(function (child) {
      var _a;
      var childHref = child.url || child.path || ((_a = child.page) === null || _a === void 0 ? void 0 : _a.path);
      return React.createElement(My.Child, {
        entity: child,
        onClick: function () {
          onItemClick(child);
        },
        key: child.id,
        icon: child.__icon,
        href: childHref,
        isActive: child.isActive,
        label: child.name
      });
    }))));
  })), mobileChildren);
});
/* @ts-ignore */
NavigationMenu.cls = cls;
NavigationMenu.defaultProps = NavigationMenuDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;